<template>
  <div>
    <v-card class="activity-tag-page mt-8 mx-8 pa-4">
      <v-card-title class="activity-tag-title">امتیاز فعالیت ها</v-card-title>
      <v-card-text>
        <v-row align="center" class="mb-4">
          <v-col cols="12" md="4" order="2" order-md="1" class="text-left">
            <v-btn color="primary" class="normal-font-btn ml-3" @click="getActivityTags">بروزرسانی</v-btn>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                    x-large
                    class="hover-link mx-1"
                    color="success"
                    v-bind="attrs"
                    v-on="on"
                    @click="openCreateDialog"
                >mdi-plus</v-icon>
              </template>
              <span class="tooltip-text">ساخت فعالیت جدید</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" md="4" order="1" order-md="2" offset-md="4">
            <v-text-field
                v-model="needle"
                label="جستجو در عنوان و توضیحات"
                color="black"
                clearable
                hide-details
                @keyup.enter="getActivityTags"
            />
          </v-col>
          <v-col cols="12">
            <v-data-table
                :headers="headers"
                :items="activityTags.data"
                :items-per-page="10"
                :loading="loading"
                disable-sort
                hide-default-footer
            >
              <template v-slot:[`item.rules`]="{ item }">
                <span>{{ item.rule_labels }}</span>
              </template>
              <template v-slot:[`item.item_files`]="{ item }">
                <span>{{ item.activity_target_titles }}</span>
              </template>
              <template v-slot:[`item.repeat_full_score_on_previous_days`]="{ item }">
                <span v-if="item.repeat_full_score_on_previous_days">بله</span>
                <span v-else>خیر</span>
              </template>
              <template v-slot:[`item.is_active`]="{ item }">
                <span v-if="item.is_active">فعال</span>
                <span v-else>غیرفعال</span>
              </template>
              <template v-slot:[`item.operation`]="{ item }">
                <v-icon class="mx-1" color="purple" @click="openEditDialog(item)">mdi-pen</v-icon>
                <v-icon class="mx-1" color="error" @click="destroy(item.id)">mdi-trash-can-outline</v-icon>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12">
            <v-pagination
                class="text-center"
                color="#696CFF"
                v-model="activityTags.current_page"
                :length="activityTags.last_page"
                circle
                @input="getActivityTags"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="formDialog" max-width="820px">
      <v-card class="activity-tag-dialog pa-4">
        <v-card-title class="activity-tag-dialog-title">
          {{ editingId ? 'ویرایش امتیاز فعالیت' : 'ساخت امتیاز فعالیت' }}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field color="black" v-model="form.title" label="نوع فعالیت" />
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                  v-model="form.rule_ids"
                  :items="rules"
                  item-text="label"
                  item-value="id"
                  label="شرط دریافت امتیاز"
                  multiple
                  chips
                  color="black"
              />
            </v-col>
            <v-col cols="12" class="activity-tag-connected-title">
              فایل های درسی و دیکته های متصل
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                  v-model="selectedCourseId"
                  :items="courses"
                  item-text="title"
                  item-value="id"
                  label="دوره ها"
                  clearable
                  color="black"
                  @change="onCourseChange"
              />
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                  v-model="form.item_file_ids"
                  :items="itemFiles"
                  :item-text="itemFileText"
                  item-value="id"
                  label="فایل های درسی"
                  multiple
                  chips
                  small-chips
                  deletable-chips
                  :disabled="!selectedCourseId && !editingId"
                  :loading="itemFilesLoading"
                  color="black"
              />
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                  v-model="form.item_dictation_ids"
                  :items="itemDictations"
                  :item-text="itemDictationText"
                  item-value="id"
                  label="دیکته ها"
                  multiple
                  chips
                  small-chips
                  deletable-chips
                  :disabled="!selectedCourseId && !editingId"
                  :loading="itemFilesLoading"
                  color="black"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field type="number" color="black" v-model.number="form.base_score" label="امتیاز اصلی فعالیت" />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field type="number" color="black" v-model.number="form.retry_score" label="امتیاز تکرار فعالیت" />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field type="number" color="black" v-model.number="form.file_cap" label="سقف امتیاز فعالیت" />
            </v-col>
            <v-col v-if="showPercentageFields" cols="12" md="3">
              <v-text-field type="number" color="black" v-model.number="form.min_percentage" label="حداقل درصد" />
            </v-col>
            <v-col v-if="showPercentageFields" cols="12" md="3">
              <v-text-field type="number" color="black" v-model.number="form.max_percentage" label="حداکثر درصد" />
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                  label="تکرار و دریافت امتیاز مجدد"
                  :items="[{text:'بله',value:true},{text:'خیر',value:false}]"
                  color="black"
                  v-model="form.repeat_full_score_on_previous_days"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                  label="وضعیت"
                  :items="[{text:'فعال',value:true},{text:'غیرفعال',value:false}]"
                  color="black"
                  v-model="form.is_active"
              />
            </v-col>
            <v-col cols="12">
              <v-textarea color="black" v-model="form.description" label="توضیحات" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="success" class="normal-font-btn" @click="submit">ذخیره</v-btn>
          <v-btn color="warning" class="normal-font-btn" @click="formDialog=false">انصراف</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="50vw">
      <v-card class="ma-0">
        <v-row class="ma-0">
          <v-col cols="12">آیا از حذف این فعالیت اطمینان دارید؟</v-col>
          <v-col cols="6">
            <v-btn color="warning" @click="finalDestroy">بله</v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="success" @click="deleteDialog=false">خیر</v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ActivityTagIndex",
  data() {
    return {
      loading: true,
      formDialog: false,
      deleteDialog: false,
      selectedEntityId: null,
      editingId: null,
      needle: '',
      rules: [],
      courses: [],
      itemFiles: [],
      itemDictations: [],
      selectedCourseId: null,
      itemFilesLoading: false,
      activityTags: {
        current_page: 1,
        data: []
      },
      form: this.emptyForm(),
      headers: [
        {text: 'شناسه', value: 'id', align: 'center', width: '2%'},
        {text: 'نوع فعالیت', value: 'title', align: 'center'},
        {text: 'شرط دریافت امتیاز', value: 'rules', align: 'center'},
        {text: 'فایل های درسی و دیکته های متصل', value: 'item_files', align: 'center'},
        {text: 'امتیاز اصلی فعالیت', value: 'base_score', align: 'center'},
        {text: 'امتیاز تکرار فعالیت', value: 'retry_score', align: 'center'},
        {text: 'سقف امتیاز فعالیت', value: 'file_cap', align: 'center'},
        {text: 'حداقل درصد', value: 'min_percentage', align: 'center'},
        {text: 'حداکثر درصد', value: 'max_percentage', align: 'center'},
        {text: 'تکرار و دریافت امتیاز مجدد', value: 'repeat_full_score_on_previous_days', align: 'center'},
        {text: 'وضعیت', value: 'is_active', align: 'center'},
        {text: 'تاریخ ساخت', value: 'created_at_fa', align: 'center'},
        {text: 'عملیات', value: 'operation', align: 'center'},
      ],
    }
  },
  computed: {
    showPercentageFields() {
      return this.rules
          .filter((rule) => this.form.rule_ids.includes(rule.id))
          .some((rule) => ['watch_video_percentage', 'listen_audio_percentage'].includes(rule.name))
    },
  },
  mounted() {
    this.getRules()
    this.getCourses()
    this.getActivityTags()
  },
  methods: {
    emptyForm() {
      return {
        title: null,
        description: null,
        base_score: 0,
        retry_score: 0,
        file_cap: null,
        min_percentage: null,
        max_percentage: null,
        first_retry_score: 0,
        second_retry_score: 0,
        previous_lesson_retry_score: null,
        daily_score_cap: null,
        repeat_full_score_on_previous_days: true,
        is_active: true,
        rule_ids: [],
        item_file_ids: [],
        item_dictation_ids: [],
      }
    },
    getRules() {
      window.axios.get('course/activity-tag/rules').then((res) => {
        this.rules = res.data.data
      })
    },
    getCourses() {
      window.axios.get('course/crud/index?per_page=100000').then((res) => {
        this.courses = res.data.data.data
      })
    },
    itemFileText(itemFile) {
      if (!itemFile) {
        return ''
      }

      const createdAt = itemFile.created_at_fa ? ' - ' + itemFile.created_at_fa : ''
      return itemFile.title + ' - ' + itemFile.id + createdAt
    },
    itemDictationText(itemDictation) {
      if (!itemDictation) {
        return ''
      }

      const createdAt = itemDictation.created_at_fa ? ' - ' + itemDictation.created_at_fa : ''
      return itemDictation.title + ' - ' + itemDictation.id + createdAt
    },
    onCourseChange() {
      this.form.item_file_ids = []
      this.form.item_dictation_ids = []
      this.itemFiles = []
      this.itemDictations = []

      if (!this.selectedCourseId) {
        return
      }

      this.getCourseItemFiles(this.selectedCourseId)
    },
    getCourseItemFiles(courseId) {
      this.itemFilesLoading = true
      window.axios.get('course/crud/get-full-items/' + courseId).then((res) => {
        const filesById = {}
        const dictationsById = {}
        res.data.data.forEach((item) => {
          if (item.files) {
            item.files.forEach((itemFile) => {
              filesById[itemFile.id] = itemFile
            })
          }

          if (item.dictations) {
            item.dictations.forEach((itemDictation) => {
              dictationsById[itemDictation.id] = itemDictation
            })
          }
        })
        this.itemFiles = Object.values(filesById)
        this.itemDictations = Object.values(dictationsById)
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      }).finally(() => {
        this.itemFilesLoading = false
      })
    },
    getActivityTags() {
      let url = 'course/activity-tag/index?page=' + (this.activityTags.current_page ?? 1)
      if (this.needle) {
        url = url + '&needle=' + encodeURIComponent(this.needle)
      }
      window.axios.get(url).then((res) => {
        this.activityTags = res.data.data
        this.loading = false
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    openCreateDialog() {
      this.editingId = null
      this.form = this.emptyForm()
      this.selectedCourseId = null
      this.itemFiles = []
      this.itemDictations = []
      this.formDialog = true
    },
    openEditDialog(activityTag) {
      this.editingId = activityTag.id
      this.selectedCourseId = null
      this.itemFiles = activityTag.item_files
      this.itemDictations = activityTag.item_dictations
      this.form = {
        title: activityTag.title,
        description: activityTag.description,
        base_score: activityTag.base_score,
        retry_score: activityTag.retry_score,
        file_cap: activityTag.file_cap,
        min_percentage: activityTag.min_percentage,
        max_percentage: activityTag.max_percentage,
        first_retry_score: activityTag.first_retry_score,
        second_retry_score: activityTag.second_retry_score,
        previous_lesson_retry_score: activityTag.previous_lesson_retry_score,
        daily_score_cap: activityTag.daily_score_cap,
        repeat_full_score_on_previous_days: activityTag.repeat_full_score_on_previous_days,
        is_active: activityTag.is_active,
        rule_ids: activityTag.rules.map((rule) => rule.id),
        item_file_ids: activityTag.item_files.map((itemFile) => itemFile.id),
        item_dictation_ids: activityTag.item_dictations.map((itemDictation) => itemDictation.id),
      }
      this.formDialog = true
    },
    submit() {
      if (!this.showPercentageFields) {
        this.form.min_percentage = null
        this.form.max_percentage = null
      }

      const url = this.editingId ? 'course/activity-tag/update/' + this.editingId : 'course/activity-tag/create'
      window.axios.post(url, this.form).then(() => {
        this.openSnackbar(this.editingId ? 'فعالیت با موفقیت ویرایش شد.' : 'فعالیت با موفقیت ساخته شد.', 'success')
        this.formDialog = false
        this.getActivityTags()
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
    destroy(activityTagId) {
      this.selectedEntityId = activityTagId
      this.deleteDialog = true
    },
    finalDestroy() {
      window.axios.delete('course/activity-tag/delete/' + this.selectedEntityId).then(() => {
        this.getActivityTags()
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      }).finally(() => {
        this.deleteDialog = false
      })
    }
  }
}
</script>

<style scoped>
.activity-tag-page {
  direction: rtl;
}

.activity-tag-title {
  justify-content: flex-end;
  font-size: 16px;
  font-weight: 700;
}

.activity-tag-dialog {
  direction: rtl;
}

.activity-tag-dialog-title {
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
}

.activity-tag-connected-title {
  color: #d71920;
  font-size: 18px;
  font-weight: 700;
}

.normal-font-btn {
  letter-spacing: normal !important;
}
</style>
